// src/api/grossiste-api.js
import { gql } from '@apollo/client';
import client from './apollo-client';

// GraphQL Queries
export const GET_GROSSISTES = gql`
  query GetGrossistes {
    grossistes {
      id
      nom
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      zoneCommentaire
      createdAt
      updatedAt
    }
  }
`;

export const GET_GROSSISTE = gql`
  query GetGrossiste($id: ID!) {
    grossiste(id: $id) {
      id
      nom
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      zoneCommentaire
      createdAt
      updatedAt
    }
  }
`;

// GraphQL Mutations
export const CREATE_GROSSISTE = gql`
  mutation CreateGrossiste($createGrossisteInput: CreateGrossisteInput!) {
    createGrossiste(createGrossisteInput: $createGrossisteInput) {
      id
      nom
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      zoneCommentaire
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_GROSSISTE = gql`
  mutation UpdateGrossiste($updateGrossisteInput: UpdateGrossisteInput!) {
    updateGrossiste(updateGrossisteInput: $updateGrossisteInput) {
      id
      nom
      adresse
      nomContact
      prenomContact
      telContact
      piecesJointes
      zoneCommentaire
      createdAt
      updatedAt
    }
  }
`;

export const DELETE_GROSSISTE = gql`
  mutation RemoveGrossiste($id: ID!) {
    removeGrossiste(id: $id)
  }
`;

// Grossiste API functions
export const grossisteApi = {
  getGrossistes: async () => {
    try {
      const { data } = await client.query({
        query: GET_GROSSISTES,
        fetchPolicy: 'network-only'
      });
      return data.grossistes;
    } catch (error) {
      console.error('Get grossistes error:', error);
      throw error;
    }
  },

  getGrossiste: async (id) => {
    try {
      const { data } = await client.query({
        query: GET_GROSSISTE,
        variables: { id },
        fetchPolicy: 'network-only'
      });
      return data.grossiste;
    } catch (error) {
      console.error(`Get grossiste ${id} error:`, error);
      throw error;
    }
  },

  createGrossiste: async (grossisteData) => {
    try {
      const { data } = await client.mutate({
        mutation: CREATE_GROSSISTE,
        variables: { createGrossisteInput: grossisteData }
      });
      return data.createGrossiste;
    } catch (error) {
      console.error('Create grossiste error:', error);
      throw error;
    }
  },

  updateGrossiste: async (grossisteData) => {
    try {
      const { data } = await client.mutate({
        mutation: UPDATE_GROSSISTE,
        variables: { updateGrossisteInput: grossisteData }
      });
      return data.updateGrossiste;
    } catch (error) {
      console.error(`Update grossiste ${grossisteData.id} error:`, error);
      throw error;
    }
  },

  removeGrossiste: async (id) => {
    try {
      const { data } = await client.mutate({
        mutation: DELETE_GROSSISTE,
        variables: { id }
      });
      return data.removeGrossiste;
    } catch (error) {
      console.error(`Remove grossiste ${id} error:`, error);
      throw error;
    }
  }
};